export default __webpack_public_path__ + "static/media/Gallery-5.eaf49646.jpg";